import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LinkSchedulerCreateObject } from '../interfaces/link-scheduler-create-object.interface';
import { LinkSchedulerObject } from '../interfaces/link-scheduler-object.interface';
import { Link } from '../interfaces/link.interface';
import { Schedule } from '../interfaces/schedule.interface';

@Injectable({
	providedIn: 'root',
})
export class SchedulerService {
	readonly url: string = 'scheduler';

	constructor(private http: HttpClient) {}

	public addScheduleInfo(addScheduleInfo: LinkSchedulerCreateObject) {
		return this.http.post(`${this.url}/UpdateScheduleInformation`, addScheduleInfo);
	}

	public deleteActiveHangfireJob(job: any) {
		return this.http.delete<boolean>(`${this.url}/DeleteHangfireJob/${job.id}`);
	}

	public checkIfSchedulesAreActiveForCompany(companyId: number)
	{
		return this.http.get<boolean>(`${this.url}/CheckIfSchedulesAreActiveForCompany/${companyId}`);
	}

	public getNextExecutionDates(linkId: number): Observable<Date[]>
	{
		return this.http.get<Date[]>(`${this.url}/GetNextLinkExecutionDates/${linkId}`);
	}
}
